module.exports = __webpack_public_path__ + "img/anker.546db414.jpg";